import { defineMessages } from "react-intl";

export const passwordExpiredMessages = defineMessages({
  cancel: {
    id: "authentication.password-expired.cancel",
    defaultMessage: "Отмена",
  },
  confirm: {
    id: "authentication.password-expired.confirm",
    defaultMessage: "Сбросить пароль",
  },
  description: {
    id: "authentication.password-expired.description",
    defaultMessage: "Для продолжения работы необходимо создать новый пароль",
  },
  title: {
    id: "authentication.password-expired.title",
    defaultMessage: "Срок действия пароля истёк",
  },
});
